var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaintRoller(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 128V32C416 14.344 401.656 0 384 0H32C14.344 0 0 14.344 0 32V128C0 145.656 14.344 160 32 160H384C401.656 160 416 145.656 416 128ZM448 64V192C448 209.656 433.656 224 416 224H256C220.656 224 192 252.656 192 288V320C174.344 320 160 334.344 160 352V480C160 497.656 174.344 512 192 512H256C273.656 512 288 497.656 288 480V352C288 334.344 273.656 320 256 320V288H416C469.031 288 512 245.031 512 192V128C512 92.656 483.344 64 448 64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintRoller);
export default __webpack_public_path__ + "static/media/paint-roller.9836869f5452b62c7bda1b49a7bf0acf.svg";
export { ForwardRef as ReactComponent };